module.exports = __webpack_public_path__ + "static/HORECA1-30414ab063e86acf5e278d071132c383.png";